import { useState, useEffect } from "react";

const COOKIE_KEY = "cookie_consent";

function loadGtag() {
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-3NGBV6RB1Y";
  document.head.appendChild(script);
  script.onload = function () {
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", "G-3NGBV6RB1Y");
    gtag("config", "AW-17914583801");
  };
}

declare global {
  interface Window {
    dataLayer?: unknown[][];
  }
}

export function initConsentOnLoad() {
  if (localStorage.getItem(COOKIE_KEY) === "accepted") {
    loadGtag();
  }
}

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
    loadGtag();
  };

  const refuse = () => {
    localStorage.setItem(COOKIE_KEY, "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-black/90 backdrop-blur-sm border-t border-white/10 p-4 md:p-6">
      <div className="mx-auto max-w-4xl flex flex-col md:flex-row items-center gap-4 text-sm text-white/90">
        <p className="flex-1 text-center md:text-left leading-relaxed">
          Ce site utilise des cookies pour mesurer l'audience et améliorer votre expérience. En cliquant sur Accepter, vous autorisez l'utilisation de cookies analytiques et publicitaires.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={refuse}
            className="px-5 py-2.5 rounded-lg border border-white/40 text-white bg-transparent hover:bg-white/10 transition-colors text-sm font-medium"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            className="px-5 py-2.5 rounded-lg bg-[hsl(24,100%,40%)] hover:bg-[hsl(24,100%,45%)] text-white transition-colors text-sm font-semibold"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
